<template>
  <div>
    <QueryForm ref="queryFormRef" @change="onQueryAction">
      <el-button type="primary" :loading="tableLoading" @click="onQueryAction">查询</el-button>
    </QueryForm>
    <DimensionCheckboxV2
      style="background-color: #f7f7f7"
      v-model="dimensionList"
      :dimensions="analysisDimensionsDisabledList"
    ></DimensionCheckboxV2>

    <div class="operate-row">
      <QueryParamsManager
        ref="queryParamsManagerRef"
        menu-id="M21269"
        :max-conditions="20"
        @select="onConditionSelect"
        @request-save="onSaveConditions"
      />

      <div class="date-picker-wrapper">
        <el-radio-group class="date-type-radio" v-model="outsideQueryForm.dateType" @change="onDateTypeChange">
          <el-radio-button :label="DATE_TYPE.DAY">分日</el-radio-button>
          <el-radio-button :label="DATE_TYPE.WEEK">分周</el-radio-button>
          <el-radio-button :label="DATE_TYPE.MONTH">分月</el-radio-button>
          <el-radio-button :label="DATE_TYPE.TOTAL">汇总</el-radio-button>
        </el-radio-group>
        <span>&ensp;</span>
        <DateRangePicker
          v-if="[DATE_TYPE.DAY, DATE_TYPE.TOTAL].includes(outsideQueryForm.dateType)"
          v-model="outsideQueryForm.dateRange"
          style="width: 220px"
          :clearable="false"
          :pickerOptions="{ disabledDate }"
          @change="onQueryAction"
        ></DateRangePicker>
        <dateWeekRange
          v-if="outsideQueryForm.dateType === DATE_TYPE.WEEK"
          v-model="outsideQueryForm.weekRange"
          range-separator="至"
          style="width: 180px"
          start-placeholder="开始周"
          end-placeholder="结束周"
          :default-value="weekDefaultValue"
          :picker-options="weekOptions"
          @change="onQueryAction"
          popper-class="week-range"
        >
        </dateWeekRange>
        <el-date-picker
          v-if="outsideQueryForm.dateType === DATE_TYPE.MONTH"
          v-model="outsideQueryForm.monthRange"
          type="monthrange"
          range-separator="至"
          style="width: 180px"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          :default-value="monthDefaultValue"
          :picker-options="monthOptions"
          @change="onQueryAction"
        >
        </el-date-picker>

        <el-button @click="showCustomTableColumnModal = true" style="margin-left: 8px">自定义列</el-button>
        <el-button :disabled="!tableData.length" :loading="exportLoading" @click="onTableExportAction">数据导出</el-button>
      </div>
    </div>

    <Viewport v-model="pageHeight">
      <div v-if="echartsOptions" style="overflow-y: auto" :style="{ height: `${pageHeight - 10}px` }">
        <div class="label-chart" v-loading="tableLoading">
          <el-select class="chart-selector" v-model="chartDimension" size="mini" @change="initialChart">
            <el-option v-for="item in columns.slice(2)" :key="item.key" :label="item.title" :value="item.key"> </el-option>
          </el-select>

          <div class="chart-wrap">
            <compare-echart :compare-options="echartsOptions" />
          </div>
        </div>

        <div class="label-table">
          <div>
            <h3 v-if="outsideQueryForm.dateType === DATE_TYPE.DAY">【分日统计方式】</h3>
            <h3 v-if="outsideQueryForm.dateType === DATE_TYPE.WEEK">【分周统计方式】</h3>
            <h3 v-if="outsideQueryForm.dateType === DATE_TYPE.MONTH">【分月统计方式】</h3>
            <h3 v-if="outsideQueryForm.dateType === DATE_TYPE.TOTAL">【汇总统计方式】</h3>
          </div>

          <el-table
            v-loading="tableLoading"
            class="common-el-table-styles summary-el-table-styles"
            ref="table"
            border
            stripe
            show-summary
            :data="tableData"
            :summary-method="tableSummaryMethod"
            @sort-change="onTableSortAction"
          >
            <el-table-column
              v-for="(col, id) in tableCols"
              :key="id"
              :prop="col.key"
              :label="col.title"
              :fixed="col.fixed"
              :show-overflow-tooltip="col.overflow"
              :min-width="col.width"
              :align="col.align"
              :sortable="col.sortable"
              :sort-orders="['descending', 'ascending', null]"
            >
              <template slot-scope="{ row }">
                <span v-if="col.key === 'tdate'"> {{ row.tdateDesc }} </span>
                <span v-else-if="col.key === 'labelNames'">
                  <el-button
                    type="text"
                    @click="toMaterialReportPage({ tdateDesc: row.tdateDesc, labelId: JSON.stringify([row.contentLabelId]) })"
                  >
                    {{ row.labelNames }}
                  </el-button>
                </span>

                <span v-else-if="col.key === 'imageStyle1LabelNames'">
                  <el-button
                    type="text"
                    @click="toMaterialReportPage({ tdateDesc: row.tdateDesc, imageStyle1LabelId: row.imageStyle1LabelId })"
                  >
                    {{ row.imageStyle1LabelNames }}
                  </el-button>
                </span>

                <span v-else-if="col.key === 'imageStyle2LabelNames'">
                  <el-button
                    type="text"
                    @click="toMaterialReportPage({ tdateDesc: row.tdateDesc, imageStyle2LabelId: row.imageStyle2LabelId })"
                  >
                    {{ row.imageStyle2LabelNames }}
                  </el-button>
                </span>

                <span v-else-if="tableNumberFields.includes(col.key)">{{ toThousands(row[col.key]) }}</span>
                <span v-else-if="tableRateFields.includes(col.key)">{{ toPercentFixed(row[col.key]) }}</span>
                <span v-else>{{ row[col.key] }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div style="text-align: right">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page.sync="page.pageId"
              :page-size="page.pageSize"
              :page-sizes="[50, 100, 200, 300]"
              :total="total"
              @current-change="getPageData"
              @size-change="onQueryAction"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </Viewport>

    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      name="AnalysisMaterLifeCustomColumn"
      v-model="showCustomTableColumnModal"
      :data="columns"
      :sub-title="['报表数据', '创角留存', '创角LTV', '创角付费留存']"
      @on-select="onTableColsChange"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick } from 'vue'
import moment from 'moment'
import { useRouter } from 'vue-router/composables'
import QueryForm from './components/analysis-label/query-form.vue'
import DimensionCheckboxV2 from '@/components/dimension/index-v2.vue'
import QueryParamsManager from '@/components/query-params-manager/index.vue'
import CompareEchart from '@/components/echarts/echart.vue'
import CustomColumn from '@/components/converter/custom-column2.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import columns from '../data/material_label_life_column.js'
import { analysisDimensions } from './data/analysis-dimensions.js'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import { getTag } from '@/api/manage.model'

import { useDateRange, DATE_TYPE, useTable } from './hooks/useLabelAnalysis.js'
const router = useRouter()

const queryFormRef = ref(null)
const queryParamsManagerRef = ref(null)
const tableCustomColsRef = ref(null)
const dimensionList = ref(['dimImageStyle1Label'])
const pageHeight = ref(300)

const outsideQueryForm = ref({
  dateType: DATE_TYPE.DAY,
  dateRange: [moment(), moment()].map((day) => day.subtract(1, 'days').format('YYYY-MM-DD')),
  weekRange: [],
  monthRange: []
})
const { weekDefaultValue, monthDefaultValue, weekOptions, monthOptions, disabledDate } = useDateRange()
const {
  showCustomTableColumnModal,
  tableCols,
  total,
  page,
  tableLoading,
  exportLoading,
  tableData,
  chartDimension,
  tableNumberFields,
  tableRateFields,
  echartsOptions,
  originQueryForm,

  getPageData,
  tableSummaryMethod,
  initialChart,
  buildParams,
  onTableSortAction,
  onTableExportAction,
  onTableColsChange
} = useTable(queryFormRef, outsideQueryForm, dimensionList)

const analysisDimensionsDisabledList = computed(() => {
  const [dimension] = dimensionList.value
  return analysisDimensions.map((item) => {
    return {
      ...item,
      disabled: item.key === dimension ? false : dimensionList.value.length > 0
    }
  })
})

const onQueryAction = () => {
  page.value.pageId = 1
  getPageData()
}

const dateRangeHandler = () => {
  const { dateRange, dateType, weekRange, monthRange } = outsideQueryForm.value
  let [beginTime, endTime] = dateRange || [undefined, undefined]

  switch (dateType) {
    case DATE_TYPE.WEEK:
      {
        const [b, e] = weekRange
        beginTime = b
        endTime = e
      }
      break
    case DATE_TYPE.MONTH:
      {
        const [b, e] = monthRange
        beginTime = b
        endTime = moment(e).endOf('month').format('YYYY-MM-DD')
      }
      break
    default:
      break
  }

  return {
    beginTime,
    endTime
  }
}
const toMaterialReportPage = async (opts) => {
  if (!Object.values(originQueryForm.value).length) return
  const { dataGroupIds, gameGroups, imgTypes, contentLabelIds, threeDLabelIds, imageStyles, ...rest } = originQueryForm.value
  const { imageStyle1LabelId, imageStyle2LabelId } = opts

  let queryOpts = {
    ...rest,
    ...dateRangeHandler(),
    dataGroupIds: dataGroupIds?.length ? JSON.stringify(dataGroupIds) : undefined,
    gameGroups: gameGroups?.length ? JSON.stringify(dataGroupIds) : undefined,
    imgTypes: imgTypes?.length ? JSON.stringify(imgTypes) : undefined,
    labelId: contentLabelIds?.length ? JSON.stringify(contentLabelIds) : undefined,
    videoLabelId: threeDLabelIds?.length ? JSON.stringify(threeDLabelIds) : undefined,
    imageStyles: imageStyles?.length ? JSON.stringify(imageStyles) : undefined
  }

  // 当点击一级二级素材样式时，才使用styleId进行参数传递
  if (imageStyle1LabelId) {
    queryOpts.styleId = JSON.stringify([imageStyle1LabelId])
  } else if (imageStyle2LabelId) {
    // 二级素材样式，获取一级素材样式id拼接后再跳转
    try {
      const { parentId } = await getTag({ labelId: opts.imageStyle2LabelId })
      const styleId = [parentId, imageStyle2LabelId]
      queryOpts.styleId = JSON.stringify(styleId)
    } catch (e) {
      console.log('getTag error output: ', e)
    }
  } else {
    queryOpts = Object.assign(queryOpts, opts)
  }
  router.push({ name: 'reportMaterialAnalysis', query: queryOpts })
}

const onDateTypeChange = (val) => {
  switch (val) {
    case DATE_TYPE.WEEK:
      {
        // 默认周一到周天
        let monday = moment().weekday(0)
        let lastday = moment().weekday(6)
        // v4.22.1 如果今天是星期一，取上周一到上周天
        if (moment().day() === 1) {
          monday = moment().weekday(-7)
          lastday = moment().weekday(-1)
        }
        outsideQueryForm.value.weekRange = [monday.format('YYYY-MM-DD'), lastday.format('YYYY-MM-DD')]
      }
      break

    case DATE_TYPE.MONTH:
      {
        // v4.22.1 例如今天是1月1日，则选中的是上月
        // 例如今天是1月2日，则选中的是本月
        let month = moment().format('YYYY-MM-01')
        const today = moment().format('YYYY-MM-DD')
        if (today.endsWith('-01')) {
          month = moment().subtract(1, 'month').format('YYYY-MM-DD')
        }
        outsideQueryForm.value.monthRange = [month, month]
      }
      break

    default:
      break
  }

  onQueryAction()
}

const onSaveConditions = () => {
  nextTick(() => {
    const params = queryFormRef.value?.getForm()
    if (dimensionList.value?.length) {
      params.dimensionList = dimensionList.value
    }
    queryParamsManagerRef.value?.openSaveDialog(params)
  })
}

const onConditionSelect = (conditions) => {
  const conditionInfo = JSON.parse(conditions.conditionInfo) || null
  if (conditionInfo) {
    const { dimensionList: dims, ...restQueryForm } = conditionInfo
    if (dims?.length) {
      dimensionList.value = dims
    }
    queryFormRef.value?.setQueryParams(restQueryForm)
  }
}

onMounted(() => {
  onQueryAction()
})
</script>

<style scoped lang="scss">
.label-chart {
  position: relative;

  .chart-selector {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }
  .chart-wrap {
    background-color: #f8f8f8;
    height: 350px;
  }
}

.operate-row {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;

  .date-picker-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 8px !important;
  }
}
.label-table {
  margin-top: 10px;
}

.tooltip-box {
  width: 320px;
  background: red;
}
</style>
